// Kéo chuột để trượt ngang list-moc-scroll trên PC (giống vuốt trên mobile)
window.addEventListener("load", function () {
	var slider = document.querySelector(".list-moc-scroll");
	if (!slider) return;

	var isDown = false;
	var startX = 0;
	var scrollLeft = 0;
	var moved = false; // đánh dấu đã kéo để chặn click ảo sau đó

	slider.addEventListener("mousedown", function (e) {
		isDown = true;
		moved = false;
		slider.classList.add("dragging");
		startX = e.pageX - slider.offsetLeft;
		scrollLeft = slider.scrollLeft;
	});

	function stop() {
		isDown = false;
		slider.classList.remove("dragging");
	}
	slider.addEventListener("mouseleave", stop);
	slider.addEventListener("mouseup", stop);

	slider.addEventListener("mousemove", function (e) {
		if (!isDown) return;
		e.preventDefault();
		var x = e.pageX - slider.offsetLeft;
		var walk = x - startX;
		if (Math.abs(walk) > 3) moved = true;
		slider.scrollLeft = scrollLeft - walk;
	});

	// Nếu vừa kéo thì nuốt sự kiện click để không mở popup/nhận mốc ngoài ý muốn
	slider.addEventListener(
		"click",
		function (e) {
			if (moved) {
				e.preventDefault();
				e.stopPropagation();
			}
		},
		true
	);
});
